import {eq} from '@shared/helpers/lang'

import {getPaymoneyAndRewardBenefit, getRewardPointBalanceWithVoucher} from '@web/actions/pointPayment'
import {APIStatus, PAYMONEY_RESULT_TYPE} from '@web/core/constants'
import {getPoints} from '@web/slices/rewardPoint/slice'
import makeSlice from '@web/slices/rewardPoint/sliceMaker'

import {initPaymentMethodManagement} from '../../actions'

const eqResultSuccess = eq(PAYMONEY_RESULT_TYPE.SUCCESS)

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initPaymentMethodManagement.fulfilled, (state, {payload}) => {
                const {
                    response: {
                        paymoneyAndPointResult: {
                            reward: {balanceAmount, welfareBalanceAmount, resultType, description},
                        },
                    },
                } = payload

                const isSuccess = eqResultSuccess(resultType)

                state.amount = isSuccess ? balanceAmount : 0
                state.cashPoint = isSuccess ? welfareBalanceAmount : 0
                state.status = isSuccess ? APIStatus.RESOLVED : APIStatus.REJECTED
                state.descriptions = getPoints({
                    totalBalance: balanceAmount ?? 0,
                    points: description.map(({text, balance, logoImageUrl, details}) => ({
                        text,
                        balance,
                        logoImageUrl,
                        rewardPointDescriptionDetails: details,
                    })),
                })
            })
            /** 포인트 조회 */
            .addCase(getRewardPointBalanceWithVoucher.pending, (state) => {
                state.status = APIStatus.FETCHING
            })
            .addCase(getRewardPointBalanceWithVoucher.fulfilled, (state, {payload: {data}}) => {
                const {welfareBalanceAmount, balanceAmount, description} = data

                state.amount = balanceAmount
                state.cashPoint = welfareBalanceAmount ?? 0
                state.status = APIStatus.RESOLVED
                state.descriptions = getPoints({
                    totalBalance: balanceAmount ?? 0,
                    points: description.map(({text, balance, logoImageUrl, details}) => ({
                        text,
                        balance,
                        logoImageUrl,
                        rewardPointDescriptionDetails: details,
                    })),
                })
            })
            .addCase(getRewardPointBalanceWithVoucher.rejected, (state) => {
                state.amount = 0
                state.cashPoint = 0
                state.status = APIStatus.REJECTED
                state.descriptions = []
            })
            /** 페이머니 + 포인트 조회  */
            .addCase(getPaymoneyAndRewardBenefit.pending, (state) => {
                state.status = APIStatus.FETCHING
            })
            .addCase(getPaymoneyAndRewardBenefit.fulfilled, (state, {payload}) => {
                const {
                    reward: {balanceAmount, welfareBalanceAmount, resultType, description},
                } = payload

                const isSuccess = eqResultSuccess(resultType)

                state.amount = isSuccess ? balanceAmount : 0
                state.cashPoint = isSuccess ? (welfareBalanceAmount ?? 0) : 0
                state.status = isSuccess ? APIStatus.RESOLVED : APIStatus.REJECTED
                state.descriptions = getPoints({
                    totalBalance: balanceAmount,
                    points: description.map(({text, balance, logoImageUrl, details}) => ({
                        text,
                        balance,
                        logoImageUrl,
                        rewardPointDescriptionDetails: details,
                    })),
                })
            })
            .addCase(getPaymoneyAndRewardBenefit.rejected, (state) => {
                state.amount = 0
                state.cashPoint = 0
                state.status = APIStatus.REJECTED
                state.descriptions = []
            })
    },
})

export default slice.reducer
